import React, {Suspense, lazy} from 'react'
import Loader from '../../../components/Loader'

//components
const RowHeader = lazy(() => import('../../../components/RowHeader'))
const MarkdownRender = lazy(() => import('../../../components/MarkdownRender'))
const HorizontalChain = lazy(() => import('../HorizontalChain'))
const PopUpCard = lazy(() => import('../PopUpCard'))
const AccountCard = lazy(() => import('../AccountCard'))
const DemographicCard = lazy(() => import('../DemographicCard'))
const UserCard = lazy(() => import('../UserCard'))
const ProviderCard = lazy(() => import('../ProviderCard'))
const LocationCard = lazy(() => import('../LocationCard'))
const EDCard = lazy(() => import('../EDCard'))
const TechnicalCard = lazy(() => import('../TechnicalCard'))
const SubscriberCard = lazy(() => import('../SubscriberCard'))
const AvailableCard = lazy(() => import('../AvailableCard'))

const Default = () => {
    return <span>Please check schema, could not render this component properly</span>
}

const CardSelector = props => {
    const components = {
        RowHeader: RowHeader,
        MarkdownRender: MarkdownRender,
        HorizontalChain: HorizontalChain,
        PopUpCard: PopUpCard,
        AccountCard: AccountCard,
        DemographicCard: DemographicCard,
        UserCard: UserCard,
        ProviderCard: ProviderCard,
        LocationCard: LocationCard,
        EDCard: EDCard,
        TechnicalCard: TechnicalCard,
        SubscriberCard: SubscriberCard,
        AvailableCard: AvailableCard,
        Default: Default,
    }

    const ComponentName = props.componentType
        ? components[props.componentType]
        : components['Default']

    return (
        <Suspense fallback={<Loader type="page" />}>
            <ComponentName {...props} />
        </Suspense>
    )
}

export default CardSelector
